import React from "react";
import {
  Box,
  Typography,
  Grid,
  Paper,
  Button,
  ButtonGroup,
} from "@mui/material";
import { Download, Refresh } from "@mui/icons-material";
import { Check } from "lucide-react";
import { generateDoc } from "../../util/GenerateDoc";
import { saveAs } from "file-saver";
export default function SuccessPage({
  glbViewer,
  data,
  moreData,
  isNight = false,
  idToken,
  first_name,
  last_name,
  configObj,
}) {
  return (
    <Box
      sx={{
        // backgroundColor: "#f5f5f5",
        // minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        boxShadow: "none",
        marginTop: "3vh",
        py: 4,
        color: isNight ? "#eef2f7" : "inherit",
        transition: "color 0.35s ease",
      }}
    >
      {/* Success Icon and Message */}
      <Box textAlign="center" mb={4}>
        <Box
          sx={{
            width: 50,
            height: 50,
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            mx: "auto",
            border: isNight ? "5px solid #eef2f7" : "5px solid black",
            transition: "border-color 0.35s ease",
          }}
        >
          <Check
            size={40}
            color="#CE1126"
            sx={{
              fontSize: "calc(3.185rem + var(--large-screen-font-bump))",
              color: "white",
            }}
          />
        </Box>
        <Typography variant="h6" sx={{ mt: 2 }}>
          Your request has been sent successfully!
        </Typography>
      </Box>

      {/* Main Content Container */}
      <Paper
        elevation={3}
        sx={{
          width: "70%",
          borderRadius: 0,
          backgroundColor: isNight ? "#566176" : "white",
          color: isNight ? "#eef2f7" : "inherit",
          padding: "30px",
          boxShadow: "none",
          transition: "color 0.35s ease, background-color 0.35s ease",
          //   p: 3,
        }}
      >
        <Grid container spacing={15}>
          {/* Left Column */}
          <Grid item width={"50%"} xs={12} md={8}>
            <div
              key="content"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1, transition: { duration: 0.3 } }}
              exit={{ opacity: 0, transition: { duration: 0.3 } }}
              className="p-4"
            >
              <div layout={false}>
                {/* <div
                  style={{
                    height: "1px",
                    width: "100%",
                    backgroundColor: isNight ? "#707a90" : "#0000000d",
                    transition: "background-color 0.35s ease",
                    marginBottom: "30px",
                  }}
                ></div> */}
                <Typography
                  fontWeight="bold"
                  textAlign={"start"}
                  sx={{
                    fontSize: "calc(0.76rem + var(--large-screen-font-bump))",
                    paddingBottom: "5px",
                  }}
                >
                  {"REQUEST SUMMARY"}
                </Typography>
                <div style={{ height: "23px" }}></div>
                <div
                  style={{
                    height: "1px",
                    width: "100%",
                    backgroundColor: isNight ? "#707a90" : "#0000000d",
                    transition: "background-color 0.35s ease",
                    marginBottom: "23px",
                  }}
                ></div>
                <Typography
                  fontWeight="bold"
                  textAlign={"start"}
                  sx={{
                    fontSize: "calc(0.71rem + var(--large-screen-font-bump))",
                    paddingBottom: "5px",
                  }}
                >
                  {data.title}
                </Typography>
                {data.rows.map((row, i) => (
                  <Box
                    key={i}
                    display="flex"
                    justifyContent="space-between"
                    marginBottom="0px"
                    marginTop="12px"
                    fontSize={"calc(0.68rem + var(--large-screen-font-bump))"}
                    // mt={1}
                  >
                    <span>{row.label}</span>{" "}
                    <span style={{ fontWeight: "bold" }}>{row.value}</span>
                  </Box>
                ))}
              </div>
              <div style={{ height: "23px" }}></div>
              <div
                style={{
                  height: "1px",
                  width: "100%",
                  backgroundColor: isNight ? "#707a90" : "#0000000d",
                  transition: "background-color 0.35s ease",
                  marginBottom: "23px",
                }}
              ></div>
              <div layout={false}>
                <Typography
                  fontWeight="bold"
                  textAlign={"start"}
                  sx={{
                    fontSize: "calc(0.71rem + var(--large-screen-font-bump))",
                    paddingBottom: "5px",
                  }}
                >
                  {moreData.title}
                </Typography>
                {moreData.rows.map((row, i) => (
                  <Box
                    key={i}
                    display="flex"
                    justifyContent="space-between"
                    marginBottom="0px"
                    marginTop="12px"
                    fontSize={"calc(0.68rem + var(--large-screen-font-bump))"}
                    // mt={1}
                  >
                    <span>{row.label}</span>{" "}
                    <span style={{ fontWeight: "bold" }}>{row.value}</span>
                  </Box>
                ))}
              </div>
            </div>
          </Grid>

          {/* Right Column */}
          <Grid item xs={12} md={4}>
            {glbViewer}
          </Grid>
        </Grid>
      </Paper>
      <ButtonGroup
        sx={{
          width: "calc(70% + 60px)",
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "2vh",
          gap: "2vh",
          boxShadow: "none",
        }}
      >
        <Button
          variant="outlined"
          onClick={async () => {
            const data = {
              name: first_name + " " + last_name,
              date: new Date().toDateString(),
              screenshots: configObj?.config.screenshots,
              config: configObj.config,
            };

            const blob = await generateDoc(data);
            const username = first_name + " " + last_name;
            const docName = "DIGITAL CONFIGURATION PROPOSAL - " + username;

            saveAs(blob, docName);
          }}
          sx={{
            fontSize: "calc(0.72rem + var(--large-screen-font-bump))",
            borderRadius: "0",
            border: "none !important",
            color: isNight ? "#eef2f7" : "#d32f2f",
            fontWeight: "bold",
            transition: "color 0.35s ease, background-color 0.35s ease",
            "&:hover": {
              border: "none !important",
              backgroundColor: isNight
                ? "rgba(255, 255, 255, 0.08)"
                : "rgba(211, 47, 47, 0.06)",
            },
          }}
        >
          Download Summary
          <Box width={"10px"} />
          <Download sx={{ fontSize: "1rem" }} />
        </Button>
        <Button
          variant="contained"
          onClick={() => window.location.reload()}
          sx={{
            fontSize: "calc(0.72rem + var(--large-screen-font-bump))",
            borderRadius: "0",
            backgroundColor: "#d32f2f",
            fontWeight: "bold",
            border: "none !important",
            boxShadow: "none",
            "&:hover": {
              backgroundColor: "#b71c1c",
              boxShadow: "none",
            },
          }}
        >
          Create New Configuration
          <Box width={"10px"} />
          <Refresh sx={{ fontSize: "1rem" }} />
        </Button>
      </ButtonGroup>
    </Box>
  );
}
